'use client';

import { ThemeProvider } from '@material-ui/core';
import { FC, ReactNode } from 'react';

import { ContentfulMicrocopy } from 'src/data/Contentful/ContentfulGetMicrocopyListing';
import { MicrocopyStoreProvider, useCreateMicrocopyStore } from 'src/stores/microcopyStore';
import { themeCreated } from 'src/theme/MUI';

interface Props {
  contentfulMicrocopy: ContentfulMicrocopy[];
  children: ReactNode;
}

const LegacyComponentProvider: FC<Props> = ({ contentfulMicrocopy, children }) => {
  const createMicrocopyStore = useCreateMicrocopyStore({}, contentfulMicrocopy);
  return (
    <ThemeProvider theme={themeCreated}>
      <MicrocopyStoreProvider createStore={createMicrocopyStore}>{children}</MicrocopyStoreProvider>
    </ThemeProvider>
  );
};

export default LegacyComponentProvider;
